import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ThumbsUpRegular from './thumbs-up-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ThumbsUpRegular {...validProps} />;
}
SvgComponent.iconName = 'thumbs-up-regular';

export const ThumbsUpRegularIcon = svgIconWrapper(SvgComponent);
